import { render, staticRenderFns } from "./CatalogoConsultaPedidos.vue?vue&type=template&id=1b540c3e"
import script from "./CatalogoConsultaPedidos.vue?vue&type=script&lang=js"
export * from "./CatalogoConsultaPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports